import { put } from "redux-saga/effects";
import importer from "common/importer";
const ChatbotActions = importer("Stores/Chatbot/Actions");
const PublicContentActions = importer("Stores/PublicContent/Actions");
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
import i18next from "i18next";

export default function* main() {
  try {
    yield put(ChatbotActions.showHideChatbot(false));
    yield put(ChatbotActions.setChatbotForPageView(false, false));
    yield put(PublicContentActions.getDrupalHomepageLoading());
    const data = (yield getMinStaticContent("landing_page", {
      lang: i18next.language,
    }))[0];
    yield put(ChatbotActions.showHideChatbot(true));
    yield put(PublicContentActions.getDrupalHomepageSuccess(data));
  } catch (error) {
    yield put(PublicContentActions.getDrupalHomepageFailure(error));
  }
}
